import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AlertService } from '../core/alert/alert.service';
import { BillingOptionsService } from '../services/billing-options.service';
import { PaymentDetails } from '../model/payment-details';
import { SubmissionService } from '../services/submission.service';

@Component({
  selector: 'app-payment-review',
  templateUrl: './payment-review.component.html',
  styleUrls: ['./payment-review.component.css']
})
export class PaymentReviewComponent implements OnInit {
  paymentDetails: PaymentDetails;
  primaryInsuredEmailAddress = '';
  saveDetailChecked = true;

  constructor(private alertService: AlertService,
              private billingOptionsService: BillingOptionsService,
              private router: Router,
              private submissionService: SubmissionService) {
  }

  ngOnInit() {
    this.billingOptionsService.getBillingOptions()
        .subscribe(billingOptions => {
          this.primaryInsuredEmailAddress = billingOptions.primaryInsuredEmailAddress;
        });
    this.paymentDetails = this.billingOptionsService.getPaymentDetails();
  }

  isEmailRequired(): boolean {
    const today = new Date();
    const paymentDate = new Date(this.paymentDetails.paymentDate);
    return paymentDate > today;
  }

  submitWithPayment() {
    this.submissionService.submitWithPayment(
        this.paymentDetails.amount,
        this.billingOptionsService.getSelectedBillee().id,
        this.paymentDetails.email,
        this.paymentDetails.servicingFee,
        this.billingOptionsService.getSelectedPaymentPlan().name,
        this.toISODateString(this.paymentDetails.paymentDate),
        this.paymentDetails.tokenId,
        this.saveDetailChecked
    )
        .subscribe(res => {
          if (res.success) {
            this.paymentDetails.confirmationNumber = res.confirmationNumber;
            this.billingOptionsService.setPaymentDetails(this.paymentDetails);
            // noinspection JSIgnoredPromiseFromCall
            this.router.navigateByUrl('/receipt');
          } else {
            this.alertService.error(res.errors.join('\n'));
          }
        });
  }

  toISODateString(date: Date): string {
    const s = date.toISOString();
    return s.slice(0, s.indexOf('T'));
  }

}
